export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-bar">
        <img src="/brand/logo-white.png" alt="" aria-hidden="true" width={46} height={40} />
        <p>© {new Date().getFullYear()} Tekdi Technologies</p>
        <nav aria-label="Footer">
          <a href="https://tekdi.net" target="_blank" rel="noreferrer">
            tekdi.net
          </a>
          <a href="/consent">Privacy &amp; consent</a>
        </nav>
      </div>
    </footer>
  );
}
